import { render, staticRenderFns } from "./DriverNewDocumentsBox.vue?vue&type=template&id=2d2ad087&"
import script from "./DriverNewDocumentsBox.vue?vue&type=script&lang=js&"
export * from "./DriverNewDocumentsBox.vue?vue&type=script&lang=js&"
import style0 from "./DriverNewDocumentsBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports